// /Icons/SvgIcons.js
import Account from "./Account";
import Automations from "./Automations";
import Cross from "./Cross";
import Devices from "./Devices";
import Download from "./Download";
import Filament from "./Filament";
import Files from "./Files";
import Find from "./Find";
import Gear from "./Gear";
import Help from "./Help";
import History from "./History";
import Home from "./home";
import Integrations from "./Integrations";
import Macro from "./Macro";
import Options from "./Options";
import Print from "./Print";
import Rename from "./Rename";
// import Sidebar_icon from "../Components/Sidebar";
import Ststistic from "./Ststistic";
import Upload from "./Upload";
import WhiteMode from "./WhiteMode";

const icons = {
  Account,
  Automations,
  Cross,
  Devices,
  Download,
  Filament,
  Files,
  Find,
  Gear,
  Help,
  History,
  Home,
  Integrations,
  Macro,
  Options,
  Print,
  Rename,
  // Sidebar_icon,
  Ststistic,
  Upload,
  WhiteMode,
};

export default icons;
